import {createAsyncThunk} from "@reduxjs/toolkit";
import {client} from "../../../_api/client";

export const HW = "hw";

export const getAllStudentHomework = createAsyncThunk(
    `${HW}/getAllStudentHomework`,
    async () => {
        const response = await client.get('/hw/mental/byStudent')
        return response.data
    }
)